export enum BarChartCategories {
  networkDiscount = 'Network Discount',
  brandHealthPaid = 'Brand Health Paid',
  yourCost = 'Your Cost',
}

export const annualCost = 'Annual Cost';

export const getPercentFrom = 100;
export const fixedDigits = 2;
export const reduceBy = 4;
export const defaultLength = 0;
export const increaseGraphWidthBy = 1;
